import * as React from 'react';
import { EStarSize, EStarTheme } from '../../../types/star';
import { Star } from '../../Star';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NoRating() {
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [/*#__PURE__*/_jsx(Star, {
      theme: EStarTheme.NotFilled,
      color: "currentColor",
      size: EStarSize.M
    }), /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      children: "\u041D\u0435\u0442 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0430"
    })]
  });
}